/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Cta_OnlineInputs */

const en_vc_cta_online = /** @type {(inputs: Vc_Cta_OnlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try VectorCraft online`)
};

const zh_vc_cta_online = /** @type {(inputs: Vc_Cta_OnlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在线使用 VectorCraft`)
};

/**
* | output |
* | --- |
* | "Try VectorCraft online" |
*
* @param {Vc_Cta_OnlineInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_cta_online = /** @type {((inputs?: Vc_Cta_OnlineInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Cta_OnlineInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_cta_online(inputs)
	return zh_vc_cta_online(inputs)
});
export { vc_cta_online as "vc.cta.online" }